<template>
  <div style="line-height: 24px" v-if="cookieInfo" class="container mb-5" v-html="getDescriptionByLang(cookieInfo)">
  </div>

</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      cookieInfo: null,
      currentLang: localStorage.getItem("igaplus-client-language") || 'az' // default, you can set dynamically or from i18n
    };
  },
  methods: {
    getDescriptionByLang(item) {
      const field = `description_${this.currentLang}`;
      return item[field] || '';
    }
  },
  async mounted() {
    try {
      const response = await axios.get('/cookieInfo'); // Adjust API URL if needed
      const data = response.data;
      if (data.length > 0) {
        this.cookieInfo = data[0];
      }
    } catch (error) {
      console.error('Failed to fetch cookie info:', error);
    }
  }
};
</script>
